<template>
  <div @mousemove="updateCursorPosition">
    <!-- GO mode cursor indicator -->
    <div
      v-show="goModeActive"
      class="go-cursor-indicator"
      :style="{ left: cursorX + 15 + 'px', top: cursorY + 15 + 'px' }"
    >
      GO
    </div>

    <!-- PR mode cursor indicator -->
    <div
      v-show="prModeActive"
      class="pr-cursor-indicator"
      :style="{ left: cursorX + 15 + 'px', top: cursorY + 15 + 'px' }"
    >
      PR
    </div>

    <!-- SN mode cursor indicator -->
    <div
      v-show="snModeActive"
      class="sn-cursor-indicator"
      :style="{ left: cursorX + 15 + 'px', top: cursorY + 15 + 'px' }"
    >
      SN
    </div>

    <!-- edit daily log -->
    <!-- <modal
      name="edit-daily-log-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      width="800"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-daily-log
        title="događaji"
        :selectedDailyLog="selectedDailyLog"
        :employeeName="selectedNameValue"
        :showContextMenuForceDeparture="false"
        :showContextMenuDeactivate="false"
        :showManualLogAdd="false"
        :dontShowAllLogs="true"
      >
      </edit-daily-log>
    </modal> -->

    <!-- add stadion-tatjana-01 modal -->
    <modal
      name="add-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <edit-stadion-tatjana-01
        :selectedItem="selectedItem"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisible="false"
        :statuses="statuses"
        :employees="employeesForEditList"
        :isEmployeesVisible="true"
        :departments="departmentData"
        :isStatusesVisible="true"
        :isDatesVisible="false"
        title="izmjena komentara"
        @saveAndCloseClicked="addItem"
        @saveAndProceedClicked="closeItem"
      />
    </modal>

    <!-- toggle late justified modal -->
    <!-- <modal
      name="toggle-late-justified-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <toggle-late-justified
        title="Vrsta kašnjenja"
        :startDate="startDate"
        :endDate="endDate"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisibl="false"
        @saveAndCloseClicked="changeLateType"
      />
    </modal> -->

    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled mjesečne prisutnosti za sve sektore</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div v-show="false" class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Filter -->
    <BulmaAccordion
      v-show="false"
      class="no-print"
      dropdown
      :icon="'caret'"
      :caretAnimation="{
        duration: '.1s',
        timerFunc: 'ease-in-out',
      }"
      :slide="{
        duration: '.1s',
        timerFunc: 'ease',
      }"
    >
      <BulmaAccordionItem>
        <h4 slot="title">Filteri...</h4>
        <div slot="content">
          <div>
            <div class="columns">
              <div class="column is-narrow">
                <label class="label">Prikaži samo kašnjenje preko </label>
              </div>
              <div class="column is-narrow">
                <input class="input" v-model.number="filterLateValue" />
              </div>
              <div class="column is-narrow">
                <label class="label">minuta </label>
              </div>
              <div class="column is-narrow">
                <button class="button" @click="filterLateApplied">
                  Primijeni
                </button>
              </div>
            </div>
          </div>
        </div>
      </BulmaAccordionItem>
    </BulmaAccordion>

    <!-- Table -->
    <div class="base-demo">
      <div
        class="reports"
        v-for="department in departments"
        :key="department.id"
      >
        <absence-list-table
          class="altable"
          :ref="`item-${department.id}`"
          :department="department"
          :selectedMonth="selectedMonth"
          :selectedYear="selectedYear"
          :departmentData="departmentData"
          :inputDailyLogs="dailyLogs"
          :statuses="statuses"
          :startDate="startDate"
          :endDate="endDate"
          :filterLateValue="filterLateValue"
          :absenceStatuses="absenceStatuses"
          @editCommentClicked="editCommentClicked"
          @editLateJustifiedClicked="editLateJustifiedClicked"
          @showEditDailyLogClicked="showEditDailyLogClicked"
          @goModeClick="handleGoModeClick"
        ></absence-list-table>
      </div>
    </div>

    <!-- spinner -->
    <div class="columns is-mobile" v-show="isLoading">
      <div class="column is-1 is-offset-half">
        <div class="container">
          <div class="has-text-centered">
            <p>loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";

import AbsenceListTable from "../parts/AbsenceListTable.vue";
import EditStadionTatjana01 from "../parts/EditStadionTatjana01.vue";
// import ToggleLateJustified from "../parts/ToggleLateJustified.vue";
import ReportService from "../../services/report.service";
import specialreportService from "../../services/specialreport.service";
import {
  getReport01TitlePropertyFromStatusId,
  getReport01recursivePropertyFromStatusId,
  getDepartmentFromEmployeeId,
} from "../../_helpers/arrangers";

// const colors = [
//   "#363636",
//   "#046FDB",
//   "#F85252",
//   "#8B54E4",
//   "#F07B3B",
//   "#3ba272",
//   "#ecfeff",
// ];

export default {
  name: "AbsenceListAll",
  components: {
    DatePicker,
    BulmaAccordion,
    BulmaAccordionItem,
    AbsenceListTable,
    EditStadionTatjana01,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departmentData: null,
      departments: [],
      dailyLogs: [],
      selectedDailyLog: null,
      statuses: [],
      selectedDepartmentId: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      selectedEmployee: null,
      selectedNameValue: null,
      startDate: new Date(),
      endDate: new Date(),
      employeeId: null,
      time3: null,
      isLoading: false,
      employeesForEditList: [],
      selectedItem: {
        boldText: "",
        note: "",
        employeeId: null,
        previewString: "",
      },
      filterLateValue: 0,
      // GO mode variables
      goModeActive: false,
      // PR mode variables
      prModeActive: false,
      // SN mode variables
      snModeActive: false,
      cursorX: 0,
      cursorY: 0,
      // Absence statuses for future dates
      absenceStatuses: [],
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    // this.getDepartments();

    // Add keyboard event listener for GO mode (Ctrl+G)
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
  },
  beforeDestroy() {
    // Remove keyboard event listeners
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  },
  activated() {},
  methods: {
    // GO mode methods
    handleKeyDown(e) {
      // Alt+G to toggle GO mode
      if (e.altKey && e.key.toLowerCase() === "g") {
        e.preventDefault();
        this.goModeActive = !this.goModeActive;
        this.prModeActive = false; // Deactivate PR mode when GO is toggled
        this.snModeActive = false; // Deactivate SN mode when GO is toggled
        console.log("GO mode:", this.goModeActive ? "ACTIVE" : "INACTIVE");
      }
      // Alt+P to toggle PR mode (Praznik)
      if (e.altKey && e.key.toLowerCase() === "p") {
        e.preventDefault();
        this.prModeActive = !this.prModeActive;
        this.goModeActive = false; // Deactivate GO mode when PR is toggled
        this.snModeActive = false; // Deactivate SN mode when PR is toggled
        console.log("PR mode:", this.prModeActive ? "ACTIVE" : "INACTIVE");
      }
      // Alt+N to toggle SN mode (Slobodan dan - Nedjela)
      if (e.altKey && e.key.toLowerCase() === "n") {
        e.preventDefault();
        this.snModeActive = !this.snModeActive;
        this.goModeActive = false; // Deactivate GO mode when SN is toggled
        this.prModeActive = false; // Deactivate PR mode when SN is toggled
        console.log("SN mode:", this.snModeActive ? "ACTIVE" : "INACTIVE");
      }
      // ESC to deactivate all modes
      if (
        e.key === "Escape" &&
        (this.goModeActive || this.prModeActive || this.snModeActive)
      ) {
        this.goModeActive = false;
        this.prModeActive = false;
        this.snModeActive = false;
        console.log("All modes: DEACTIVATED");
      }
    },
    handleKeyUp() {
      // Can be used if we want GO mode only while key is held
    },
    updateCursorPosition(e) {
      this.cursorX = e.clientX;
      this.cursorY = e.clientY;
    },
    handleGoModeClick(data) {
      if (this.goModeActive) {
        console.log("GO mode click detected:", data);
        this.sendGodisnjiOdmor(data);
        return;
      }

      if (this.prModeActive) {
        console.log("PR mode click detected:", data);
        this.sendPraznik(data);
        return;
      }

      if (this.snModeActive) {
        console.log("SN mode click detected:", data);
        this.sendSN(data);
        return;
      }
    },
    sendGodisnjiOdmor(data) {
      const employeeId = data.emp.employeeId;
      const employeeName =
        this.$store.state.general.employees.find((e) => e.id === employeeId)
          ?.name || data.emp.firstName + " " + data.emp.lastName;

      this.selectedDepartmentId = data.id;
      this.startDate = data.dt;
      this.employeeid = employeeId;

      let nextDay = new Date(this.startDate);
      nextDay.setDate(this.startDate.getDate() + 1);
      this.endDate = nextDay;
      this.endDate.setHours(0, 0, 0, 0);

      // Status ID 2 = Godišnji odmor, recursive = "R"
      const requestData = {
        boldText: employeeName,
        note: "",
        userReportId: 2,
        isConfirmed: true,
        employeeId: employeeId,
        statusId: 2,
        sRecursive: "R",
      };

      console.log("Sending Godišnji odmor request:", requestData);

      specialreportService
        .PostDailyReport01(requestData, this.startDate, "Godišnji odmor")
        .then((rsp) => {
          console.log("Godišnji odmor response:", rsp);
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            employeeId,
            null
          ).then(() => {
            console.log(
              "Refreshing table for department:",
              this.selectedDepartmentId
            );
            this.$refs[`item-${this.selectedDepartmentId}`][0].refresh();
          });
        })
        .catch((err) => {
          console.error("Error sending Godišnji odmor:", err);
        });
    },
    sendPraznik(data) {
      const employeeId = data.emp.employeeId;
      const employeeName =
        this.$store.state.general.employees.find((e) => e.id === employeeId)
          ?.name || data.emp.firstName + " " + data.emp.lastName;

      this.selectedDepartmentId = data.id;
      this.startDate = data.dt;
      this.employeeid = employeeId;

      let nextDay = new Date(this.startDate);
      nextDay.setDate(this.startDate.getDate() + 1);
      this.endDate = nextDay;
      this.endDate.setHours(0, 0, 0, 0);

      // Status ID 6 = Praznik, recursive = "N"
      const requestData = {
        boldText: employeeName,
        note: "",
        userReportId: 2,
        isConfirmed: true,
        employeeId: employeeId,
        statusId: 6,
        sRecursive: "N",
      };

      console.log("Sending Praznik request:", requestData);

      specialreportService
        .PostDailyReport01(requestData, this.startDate, "Praznik")
        .then((rsp) => {
          console.log("Praznik response:", rsp);
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            employeeId,
            null
          ).then(() => {
            console.log(
              "Refreshing table for department:",
              this.selectedDepartmentId
            );
            this.$refs[`item-${this.selectedDepartmentId}`][0].refresh();
          });
        })
        .catch((err) => {
          console.error("Error sending Praznik:", err);
        });
    },
    sendSN(data) {
      const employeeId = data.emp.employeeId;
      const employeeName =
        this.$store.state.general.employees.find((e) => e.id === employeeId)
          ?.name || data.emp.firstName + " " + data.emp.lastName;

      this.selectedDepartmentId = data.id;
      this.startDate = data.dt;
      this.employeeid = employeeId;

      let nextDay = new Date(this.startDate);
      nextDay.setDate(this.startDate.getDate() + 1);
      this.endDate = nextDay;
      this.endDate.setHours(0, 0, 0, 0);

      // Status ID 8 = SN (Slobodan dan - Nedjela), recursive = "N"
      const requestData = {
        boldText: employeeName,
        note: "",
        userReportId: 2,
        isConfirmed: true,
        employeeId: employeeId,
        statusId: 8,
        sRecursive: "N",
      };

      console.log("Sending SN request:", requestData);

      specialreportService
        .PostDailyReport01(requestData, this.startDate, "SN")
        .then((rsp) => {
          console.log("SN response:", rsp);
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            employeeId,
            null
          ).then(() => {
            console.log(
              "Refreshing table for department:",
              this.selectedDepartmentId
            );
            this.$refs[`item-${this.selectedDepartmentId}`][0].refresh();
          });
        })
        .catch((err) => {
          console.error("Error sending SN:", err);
        });
    },

    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);

      this.resetUi(true);
      this.getDepartments();
      // this.getData();
    },

    addItem(item) {
      this.$modal.hide("add-stadion-tatjana-01-modal");
      console.log("xxItemxx");
      console.log(item);

      // let i = "Godišnji odmor";
      let statusId = item.statusId;
      let i = getReport01TitlePropertyFromStatusId(item.statusId);
      let employeeId = item.employeeId;
      this.employeeid = employeeId;
      let employeeName = this.$store.state.general.employees.find(
        (e) => e.id === employeeId
      ).name;
      let recursive = getReport01recursivePropertyFromStatusId(statusId);
      console.log("i");
      console.log(i);
      console.log(statusId);
      console.log(employeeId);
      console.log(employeeName);
      console.log(recursive);
      let data = {
        boldText: employeeName,
        note: item.note,
        userReportId: 2,
        isConfirmed: true,
        employeeId: item.employeeId,
        statusId: statusId,
        sRecursive: recursive,
      };
      console.log("gododmor");
      console.log(data);
      console.log("startni datum");
      console.log(this.startDate);
      specialreportService
        .PostDailyReport01(data, this.startDate, i)
        .then((rsp) => {
          console.log(rsp);
          console.log("hic 111");
          console.log(this.employeeId);
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            this.employeeid,
            null
          ).then(() => {
            // this.resetUi(true);
            // sad se pozove child ref i
            console.log("hic222!");
            console.log(this.$refs[`item-${this.selectedDepartmentId}`]);
            this.$refs[`item-${this.selectedDepartmentId}`][0].refresh();
          });
        });
    },
    closeItem() {
      this.$modal.hide("add-stadion-tatjana-01-modal");
    },
    editCommentClicked(data) {
      this.employeesForEditList = [];
      console.log("22");
      console.log(data.emp);
      this.selectedItem.employeeId = data.emp.employeeId;
      this.selectedItem.note = ""; // Reset note field
      console.log(this.selectedItem);
      this.employeesForEditList = [];
      this.startDate = data.dt;

      let nextDay1 = new Date(this.startDate);
      nextDay1.setDate(this.startDate.getDate() + 1);
      this.endDate = nextDay1;
      console.log(this.tomorrow);
      this.endDate.setHours(0, 0, 0, 0);

      this.selectedDepartmentId = data.id;
      this.employeesForEditList.push({
        id: data.emp.employeeId,
        name: data.emp.firstName + " " + data.emp.lastName,
        departmentName: getDepartmentFromEmployeeId(
          this.$store.state.general.departmentData,
          data.emp.employeeId
        ),
      });
      console.log("23");
      this.selectedDailyLog = data.dl;
      console.log(data.dl);
      this.$modal.show("add-stadion-tatjana-01-modal");
    },
    editLateJustifiedClicked(data) {
      this.selectedDailyLog = data.dl;
      this.$modal.show("toggle-late-justified-modal");
    },
    showEditDailyLogClicked(data) {
      this.selectedDailyLog = data.dl;
      console.log(data);
      this.selectedEmployee = data.emp;
      this.selectedNameValue =
        this.selectedEmployee.firstName + " " + this.selectedEmployee.lastName;
      this.$modal.show("edit-daily-log-modal");
    },
    changeLateType(t) {
      console.log(t);
      this.$modal.hide("toggle-late-justified-modal");
      this.resetUi(true);
      // this.getData();
    },

    modalClosed() {},
    getDepartments() {
      this.isLoading = true;
      ReportService.GetStatuses().then((response) => {
        this.statuses = response.data;
        ReportService.GetAllDepartmentsOfMyCompanyHistoricallyByMonth(
          this.selectedMonth,
          this.selectedYear
        ).then((response) => {
          // reset ui
          // console.log(response.data);
          this.departmentData = response.data;
          this.arrangeSectors(response.data);
          this.arrangeEmployees(response.data);

          // Fetch absence statuses for showing planned absences in future dates
          ReportService.GetEmployeesWithAbsenceStatusByMonthAndYear(
            this.selectedMonth,
            this.selectedYear
          )
            .then((absenceResponse) => {
              this.absenceStatuses = absenceResponse.data;
              console.log("Absence statuses loaded:", this.absenceStatuses);
              this.isLoading = false;
            })
            .catch((err) => {
              console.error("Error fetching absence statuses:", err);
              this.isLoading = false;
            });
        });
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
    },
    resetUi(isFull = true) {
      this.dailyLogs = [];
      this.departments = [];
      this.absenceStatuses = [];
      if (isFull) {
        this.selectedDepartmentId = null;
        this.selectedEmployee = null;
        this.selectedItem = {
          boldText: "",
          note: "",
          employeeId: null,
          previewString: "",
        };
      }
    },
    filterLateApplied() {
      this.resetUi();
      // this.getData();
      console.log(this.filterLateValue);
    },
  },
};
</script>

<style scoped>
/* GO mode cursor indicator */
.go-cursor-indicator {
  position: fixed;
  background-color: #3ba272;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  user-select: none;
}

/* PR mode cursor indicator */
.pr-cursor-indicator {
  position: fixed;
  background-color: #8b54e4;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  user-select: none;
}

/* SN mode cursor indicator */
.sn-cursor-indicator {
  position: fixed;
  background-color: #f07b3b;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  user-select: none;
}

.ex1 {
  margin-top: 30px;
}
.cmitem {
  /* margin: 20px;
  border-color: blue;
  border-width: 2px; */
  width: 150px;
  border: none;
  background-color: inherit;
  padding: 14px 28px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
}

/* .base-demo {
  width: 2700px;
} */

.cmitem:hover {
  background: #c3ffeb;
}

.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}
.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 0px !important;
  /* flex: 0 0 0 0px !important; */
}
</style>
